export const CPF_LENGTH = 14
export const PASSWORD_LENGTH = 6
